// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ApiManagementController from "./api_management_controller";
application.register("api-management", ApiManagementController);

import AutoRefreshController from "./auto_refresh_controller";
application.register("auto-refresh", AutoRefreshController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import BulkSmsController from "./bulk_sms_controller";
application.register("bulk-sms", BulkSmsController);

import CampaignWizardController from "./campaign_wizard_controller";
application.register("campaign-wizard", CampaignWizardController);

import CsvUploadController from "./csv_upload_controller";
application.register("csv-upload", CsvUploadController);

import CurrencySelectorController from "./currency_selector_controller";
application.register("currency-selector", CurrencySelectorController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import DropzoneController from "./dropzone_controller";
application.register("dropzone", DropzoneController);

import EmailGateController from "./email_gate_controller";
application.register("email-gate", EmailGateController);

import ExpandableFormController from "./expandable_form_controller";
application.register("expandable-form", ExpandableFormController);

import ExpandableRowController from "./expandable_row_controller";
application.register("expandable-row", ExpandableRowController);

import GlobalSettingsController from "./global_settings_controller";
application.register("global-settings", GlobalSettingsController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import OrganizationSwitcherController from "./organization_switcher_controller";
application.register("organization-switcher", OrganizationSwitcherController);

import PasskeyAuthenticationController from "./passkey_authentication_controller";
application.register("passkey-authentication", PasskeyAuthenticationController);

import PasskeyConditionalController from "./passkey_conditional_controller";
application.register("passkey-conditional", PasskeyConditionalController);

import PasskeyRegistrationController from "./passkey_registration_controller";
application.register("passkey-registration", PasskeyRegistrationController);

import PurchaseCalculatorController from "./purchase_calculator_controller";
application.register("purchase-calculator", PurchaseCalculatorController);

import RecipientSearchController from "./recipient_search_controller";
application.register("recipient-search", RecipientSearchController);

import SegmentedController from "./segmented_controller";
application.register("segmented", SegmentedController);

import SelectionCountController from "./selection_count_controller";
application.register("selection-count", SelectionCountController);

import SmsFormController from "./sms_form_controller";
application.register("sms-form", SmsFormController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import TemplateComposeController from "./template_compose_controller";
application.register("template-compose", TemplateComposeController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);
